/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type AddZoomAccountMutationInput = {
    clientMutationId?: string | null | undefined;
    isUserLevelZoomAccount?: boolean | null | undefined;
    orgRelayId: string;
    redirect: string;
    verificationCode: string;
};
export type AddZoomAccountMutationVariables = {
    input: AddZoomAccountMutationInput;
};
export type AddZoomAccountMutationResponse = {
    readonly addZoomAccount: {
        readonly clientMutationId: string | null;
    } | null;
};
export type AddZoomAccountMutation = {
    readonly response: AddZoomAccountMutationResponse;
    readonly variables: AddZoomAccountMutationVariables;
};



/*
mutation AddZoomAccountMutation(
  $input: AddZoomAccountMutationInput!
) {
  addZoomAccount(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "AddZoomAccountMutationPayload",
            "kind": "LinkedField",
            "name": "addZoomAccount",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "AddZoomAccountMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "AddZoomAccountMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "1785588d8f3ab6a9ed6a6f194ed6dc5f",
            "id": null,
            "metadata": {},
            "name": "AddZoomAccountMutation",
            "operationKind": "mutation",
            "text": "mutation AddZoomAccountMutation(\n  $input: AddZoomAccountMutationInput!\n) {\n  addZoomAccount(input: $input) {\n    clientMutationId\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '5792b87ddbdcb8396fbbe0fafef4b7f9';
export default node;
